import {
  GET_HOLIDAY,
  SHOW_HOLIDAY,
  CREATE_HOLIDAY,
  EDIT_HOLIDAY,
  DELETE_HOLIDAY
} from "@/store/modules/mutation-types";

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_HOLIDAY]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/holidays",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [SHOW_HOLIDAY]({ dispatch }, params) {
      let url = "/kanri/holidays/" + params.id;
      const res = await dispatch("apiGet", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [CREATE_HOLIDAY]({ dispatch }, params) {
      const res = await dispatch("apiPost", {
        url: "/kanri/holidays",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [EDIT_HOLIDAY]({ dispatch }, params) {
      let url = "/kanri/holidays/" + params.id;
      const res = await dispatch("apiPatch", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [DELETE_HOLIDAY]({ dispatch }, params) {
      let url = "/kanri/holidays/" + params.id;
      const res = await dispatch("apiDelete", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    }
  },
  mutations: {}
};
